import React from "react";
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
// ✅ Import your pages/components
import MainLayout from "../components/MainLayout";
import Home from "../pages/Home";
import About from "../pages/About";
import Contact from "../pages/Contact";
import CreateStory from "../pages/CreateStory";

import AdminLogin from '../admin/pages/AdminLogin';
import LoginPage from "../pages/LoginPage";
import RegisterPage from '../pages/RegisterPage';
import Services from "../pages/Services";
import StoryViewPage from '../pages/StoryViewPage';
import Stories from '../pages/Stories';

import AllStories from "../admin/pages/AllStories";
import AdminMainlayout from "../admin/components/AdminMainlayout";
import Allusers from "../admin/pages/Allusers";
import HomepageStories from "../admin/pages/HomepageStories";
import EditStory from "../pages/EditStory";
import   Termsandconditions from "../pages/Termsandconditions";
import AllStory from "../pages/Allstory";
import AllPayments from "../admin/pages/AllPayments";

import ForgetPassword from "../pages/auth/ForgetPassword";
import VerifyOTP from "../pages/auth/VerifyOTP";
import ResetPassword from "../pages/auth/ResetPassword";
import LoginWithPassword from "../pages/LoginWithPassword";
import MobileOTPVerify from "../pages/auth/MobileOTPVerify";
import KidsStory from "../pages/KidsStory";
import Gallery from "../pages/Gallery";
import NotFound from "../pages/NotFound";
import Contribute from "../pages/Donation";
const Allroutes = () => {
    return (
        <Router basename={'/'} >
            <Routes>
                <Route exact path="/" element={<MainLayout><Home /></MainLayout>} />
 <Route exact path="/contribute" element={<MainLayout><Contribute /></MainLayout>} />
 <Route exact path="/gallery" element={<MainLayout><Gallery/></MainLayout>} />
  <Route exact path="/kidsstory" element={<MainLayout><KidsStory/></MainLayout>} />
                <Route exact path="/allstory" element={<MainLayout><AllStory /></MainLayout>} />
               <Route exact path="/aboutus" element={<MainLayout><About /></MainLayout>} />
                <Route exact path="/contactus" element={<MainLayout><Contact /></MainLayout>} />
                <Route exact path="/services" element={<MainLayout><  Services /></MainLayout>} />
                <Route exact path="/createstory" element={<MainLayout><CreateStory/></MainLayout>} />
                 {/* <Route exact path="/storyviewpage" element={<MainLayout><StoryViewPage/></MainLayout>} /> */}
                <Route exact path="/login" element={<MainLayout><LoginPage/></MainLayout>} />
                <Route exact path="/login-with-password" element={<MainLayout><LoginWithPassword/></MainLayout>} />
                <Route exact path="/verify-otp-with-mobilenumber" element={<MainLayout><MobileOTPVerify/></MainLayout>} />
         
                <Route exact path="/termsandconditions" element={<MainLayout><  Termsandconditions/></MainLayout>} />
                <Route exact path="/stories" element={<MainLayout><Stories/></MainLayout>} />
              
                <Route exact path="/register" element={<MainLayout><RegisterPage/></MainLayout>} />

                <Route exact path="/story/:slug" element={<MainLayout><StoryViewPage/></MainLayout>} />

                <Route exact path="/edit-story/:slug" element={<MainLayout><EditStory/></MainLayout>} />

                <Route exact path="/forget-password" element={<MainLayout><ForgetPassword /></MainLayout>} />
                <Route exact path="/verify-otp" element={<MainLayout><VerifyOTP /></MainLayout>} />
                <Route exact path="/reset-password" element={<MainLayout><ResetPassword /></MainLayout>} />

                {/* Admin */}
                <Route exact path="/admin" element={<AdminLogin />} />
                <Route exact path="/admin/login" element={<AdminLogin />} />
                <Route exact path="/admin/all-stories" element={<AdminMainlayout title={"All Stories"}><AllStories /></AdminMainlayout>} />
                <Route exact path="/admin/homepage-stories" element={<AdminMainlayout title={"Homepage Stories"}><HomepageStories /></AdminMainlayout>} />
                <Route exact path="/admin/all-users" element={<AdminMainlayout title={"Registered Users"}><Allusers /></AdminMainlayout>} />
                <Route exact path="/admin/all-payments" element={<AdminMainlayout title={"Payments"}><AllPayments /></AdminMainlayout>} />
                <Route path="*" element={<MainLayout><NotFound /></MainLayout>} />
            </Routes>
        </Router>
    )
}

export default Allroutes;
